import type { FaireProductEntity } from "../../entity_types/product";

export const p_4f28b87jzr: FaireProductEntity = {
  token: "p_4f28b87jzr",
  type: "product",
  name: "925 Eternity Band",
  brandToken: "b_pnfabwsu5v",
  brandName: "Glam Bar Bazaar",
  imageUrl:
    "https://cdn.faire.com/fastly/12837f51a1336b35cc4afa81fc2eb6bf9f8f8b95cf5eddae6441c34e6fac020c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6aca5f8c84e54e5627ab9dc4a8a5e194cf38e2ea4a6572077b5795260121ec2b.jpeg",
  ],
  priceDollars: 34.8,
  description:
    "Material: 925 Sterling silver plated 18k gold\n\nAAAAA Cubic zirconia crystals\n",
  tags: [],
  msrpDollars: 58,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:54.142Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
